var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { alertState } from "@recoil/assessmentState";
import { userInfoLoginState } from "@recoil/userState";
import * as CONST from "@utils/Const";
import { PromiseHttp } from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import { useTrans } from "@utils/langs/useTrans";
import { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import * as XLSX from "xlsx";
export const DataConsentList = ({ imgList, option, disabled, custNo, FinishPops }) => {
    const t = useTrans();
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const [img, setImg] = useState(imgList[0]);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadFileName, setUploadFileName] = useState("");
    const [completeFile, setCompleteFile] = useState(null);
    const [completeFileName, setCompleteFileName] = useState("");
    const [fileCnt, setFileCnt] = useState(0);
    const fileInputRef = useRef(null);
    let timer;
    const [pfArr, setPfArr] = useState([]);
    const [pfCnt, setPfCnt] = useState([]);
    const [pfListCk, setPfListCk] = useState(false);
    let excelNoArr = pfArr.filter((list, idx) => idx != 0 && list.excelNo);
    const ingNum = Math.round((pfCnt.length / excelNoArr.length) * 100);
    // 성공 및 실패 데이터
    let success = [];
    let fail = [];
    for (let i = 0; i < pfCnt.length; i++) {
        if (pfCnt[i].data.msg == "fail" || pfCnt[i].codeNum == 9999) {
            fail.push(pfCnt[i].body);
        }
        else if (pfCnt[i].data.msg == "success") {
            success.push(pfCnt[i].body);
        }
    }
    useEffect(() => {
        if (pfListCk) {
            handlePfAfter();
        }
    }, [pfListCk]);
    const openAlert = (msg) => {
        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: msg }));
        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
    };
    const handlePfAfter = () => __awaiter(void 0, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: option.httpMethod,
            appPath: `/energyreport/file/pf/after?custNo=${custNo}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum != CONST.API_200) {
                openAlert(data.errorList !== null ? data.errorList.map((err) => err.msg) : t("에러문구.데이터동의관리500에러"));
            }
            setPfListCk(false);
        }
    });
    // 한전 이동
    const Link = () => {
        window.open("https://edsm.kepco.co.kr/", "_blank");
    };
    // 엑셀 양식 다운
    const ExcelDownload = (url) => {
        window.open(url, "_blank");
    };
    // PDF 가이드 다운
    const PdfGuideDownload = (url) => {
        fetch(url).then((response) => {
            response.blob().then((blob) => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement("a");
                alink.href = fileURL;
                const fileName = url.split("/").pop();
                alink.download = fileName;
                alink.click();
                window.URL.revokeObjectURL(fileURL);
            });
        });
    };
    //페이지
    const PageClick = (item) => {
        setImg(item);
    };
    //파일 등록
    const fileInput = (e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
            openAlert(t("에러문구.파일형식"));
            return;
        }
        if (file) {
            setUploadFile(file);
            setUploadFileName(file.name);
            setCompleteFileName("");
            setCompleteFile(null);
            setFileCnt(0);
            if (option.httpMethod === "POST") {
                PfUpload(file);
            }
        }
    };
    //업로드 방식 분기
    const checkUpload = (file) => {
        if (option.httpMethod == "POST") {
            handlePfUolad();
        }
        if (option.httpMethod == "POSTF") {
            fileUpload(file);
        }
    };
    //Pf 파일 읽기
    const PfUpload = (file) => {
        const reader = new FileReader();
        const formData = new FormData();
        formData.append("files", file);
        reader.onload = () => {
            try {
                const fileData = reader.result;
                const xlsxUpload = XLSX.read(fileData, { type: "binary" });
                const xlsxSheet = xlsxUpload.Sheets[xlsxUpload.SheetNames[0]];
                const xlsxSheet1 = XLSX.utils.sheet_to_json(xlsxSheet);
                // 엑셀 헤드 추출
                const xlsxHeader = XLSX.utils.sheet_to_json(xlsxSheet, {
                    header: 1,
                    defval: "",
                });
                setPfArr(xlsxSheet1);
            }
            catch (err) {
                openAlert(t("에러문구.데이터동의관리500에러"));
                setUploadFileName("");
                return;
            }
        };
        reader.readAsArrayBuffer(file);
        setPfCnt([]);
    };
    //POST 파일 업로드
    const handlePfUolad = () => __awaiter(void 0, void 0, void 0, function* () {
        let data = [];
        let index = 0;
        if (isNaN(ingNum)) {
            openAlert(t("에러문구.파일컬럼형식"));
        }
        pfArr
            .filter((list, idx) => idx != 0 && list.excelNo)
            .forEach((list) => __awaiter(void 0, void 0, void 0, function* () {
            data = yield PromiseHttp({
                httpMethod: option.httpMethod,
                appPath: option.appPath,
                appQuery: {
                    excelNo: list.excelNo,
                    custNo: list.custNo,
                    billYm: list.billYm,
                    jiPwrfact: list.jiPwrfact,
                    jnPwrfact: list.jnPwrfact,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (index == pfArr.length - 2) {
                        setPfListCk(true);
                    }
                    setPfCnt((status) => {
                        return [...status, data];
                    });
                }
                return ++index;
            }
            return data;
        }));
        if (data) {
            setCompleteFileName(uploadFileName);
            setUploadFileName("");
        }
    });
    //POSTF 파일 업로드
    const fileUpload = (file) => __awaiter(void 0, void 0, void 0, function* () {
        setUploadFile(null);
        setUploadFileName("");
        setCompleteFileName(file.name);
        const formData = new FormData();
        formData.append("file", file);
        let data = null;
        data = yield PromiseHttp({
            httpMethod: option.httpMethod,
            appPath: option.appPath,
            appQuery: formData,
            userToken: userInfo.loginInfo.token,
            onUploadProgress: (progressEvent) => {
                const percentComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                // 실제 진행률이 너무 빠른 경우 자연스럽게 진행되도록 설정
                if (percentComplete > fileCnt + 10) {
                    const interval = setInterval(() => {
                        setFileCnt((prev) => {
                            if (prev >= percentComplete || prev >= 99) {
                                clearInterval(interval);
                                return percentComplete >= 100 && fileCnt > 100 ? 99 : prev;
                            }
                            return prev + 1;
                        });
                    }, 100);
                }
            },
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompleteFile(data.body);
                setFileCnt(100);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: data.errorList !== null && data.status == CONST.APISTATUS_500
                        ? t("에러문구.데이터동의관리500에러")
                        : data.errorList
                            .map((err) => (/^\d*$/.test(err.field) ? t("라벨.번라인", [err.field, err.msg]) : err.msg))
                            .join("\n") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setFileCnt(100);
            }
        }
    });
    //파일 취소
    const uploadCancel = () => {
        setUploadFile(null);
        setUploadFileName("");
        if (option.httpMethod === "POST") {
            setPfArr([]);
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "info__input" }, { children: [_jsx("div", Object.assign({ className: "page-top" }, { children: _jsxs("h3", { children: [option.title, _jsx("span", {})] }) })), _jsxs("div", Object.assign({ className: "content__info" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsxs("div", Object.assign({ className: "right" }, { children: [option.downloadExcel ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: () => ExcelDownload(option.excelUrl) }, { children: _jsx("span", { children: t("라벨.엑셀양식다운로드") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-white", onClick: () => Link() }, { children: _jsx("span", Object.assign({ className: "icon-go txt-gray" }, { children: t("라벨.한전바로가기") })) }))), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: () => PdfGuideDownload(option.pdfUrl) }, { children: _jsxs("span", Object.assign({ className: "icon-down" }, { children: ["PDF ", t("라벨.가이드")] })) }))] })) })), _jsx("div", Object.assign({ className: "img-wrap" }, { children: imgList
                                .filter((image) => image.id == img.id)
                                .map((item, idx) => (_jsx("img", { src: item.url, alt: item.alt }, "fileImg_" + idx.toString()))) })), _jsx("div", Object.assign({ className: "paging mt-8" }, { children: _jsx("ul", Object.assign({ className: "paging__button" }, { children: imgList.map((item, idx) => (_jsx("li", Object.assign({ onClick: (e) => PageClick(item) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault(), className: item.id == img.id ? "active" : "" }, { children: idx + 1 })) }), "filePage_" + idx.toString()))) })) })), _jsxs("ul", Object.assign({ className: "upload-area", hidden: !option.uploadExcel }, { children: [uploadFileName.length <= 0 && completeFileName.length <= 0 && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("input", { type: "file", accept: ".xls,.xlsx", onChange: (e) => fileInput(e), style: { display: "none" }, ref: fileInputRef }), _jsx("button", Object.assign({ type: "button", className: "btn-basic w200", onClick: () => fileInputRef.current.click(), disabled: disabled }, { children: _jsx("span", { children: t("라벨.가져오기") }) }))] }))] })), uploadFileName.length > 0 && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", { children: _jsx("span", { children: uploadFileName }) }) })), _jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: () => checkUpload(uploadFile) }, { children: _jsx("span", { children: t("라벨.업로드") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: uploadCancel }, { children: _jsx("span", { children: t("라벨.취소") }) }))] }))] })), completeFileName.length > 0 && option.httpMethod == "POSTF" && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", { children: fileCnt < 100 && (_jsx("span", Object.assign({ className: `uploading ${fileCnt > 99 ? "end" : ""}` }, { children: completeFileName }))) }) })), fileCnt > 99 ? (_jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("input", { type: "file", accept: ".xls,.xlsx", onChange: (e) => fileInput(e), style: { display: "none" }, ref: fileInputRef }), _jsx("button", Object.assign({ type: "button", className: "btn-basic w200", onClick: () => fileInputRef.current.click() }, { children: _jsx("span", { children: t("라벨.가져오기") }) }))] }))) : (_jsx("div", Object.assign({ className: "progressbar" }, { children: _jsxs("div", Object.assign({ className: "progress-value" }, { children: [_jsx("progress", { value: fileCnt, max: "100" }), _jsx("p", Object.assign({ className: "value" }, { children: _jsxs("span", { children: [fileCnt, "%"] }) }))] })) })))] })), completeFile && option.httpMethod == "POSTF" && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.완료") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", { children: _jsx("span", Object.assign({ className: "uploading end" }, { children: completeFileName })) }) })), _jsx("p", Object.assign({ className: "endtxt" }, { children: completeFile }))] })), completeFileName.length > 0 && option.httpMethod == "POST" && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", { children: ingNum < 100 && (_jsx("span", Object.assign({ className: `uploading ${ingNum == 100 ? "end" : ""}` }, { children: completeFileName }))) }) })), ingNum > 99 || isNaN(ingNum) ? (_jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("input", { type: "file", accept: ".xls,.xlsx", onChange: (e) => fileInput(e), style: { display: "none" }, ref: fileInputRef }), _jsx("button", Object.assign({ type: "button", className: "btn-basic w200", onClick: () => fileInputRef.current.click() }, { children: _jsx("span", { children: t("라벨.가져오기") }) }))] }))) : (_jsx("div", Object.assign({ className: "progressbar" }, { children: _jsxs("div", Object.assign({ className: "progress-value" }, { children: [_jsx("progress", { value: ingNum, max: "100" }), _jsx("p", Object.assign({ className: "value" }, { children: _jsxs("span", { children: [ingNum, "%"] }) }))] })) })))] })), ingNum > 99 && option.httpMethod == "POST" && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.완료") })), _jsx("ul", Object.assign({ className: "filelist end" }, { children: _jsxs("li", { children: [_jsx("span", { children: completeFileName }), _jsxs("div", Object.assign({ className: "case-info" }, { children: [_jsxs("p", Object.assign({ className: "case-ok" }, { children: [_jsx("strong", { children: t("라벨.성공") }), _jsxs("span", { children: [success.length, " ", t("라벨.개")] })] })), _jsxs("p", Object.assign({ className: "case-no" }, { children: [_jsx("strong", { children: t("라벨.실패") }), _jsxs("span", { children: [fail.length, " ", t("라벨.개")] })] })), _jsx("button", Object.assign({ type: "button", className: "btn-go js-open", "data-pop": "pop-finish-ok", onClick: (e) => FinishPops(e, success, fail, completeFileName) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD31D\uC5C5\uCC3D \uC5F4\uAE30" })) }))] }))] }) }))] }))] }))] }))] })) }));
};
